import { Text } from '@zillow/constellation-10';

export const SmallDropzone = () => <Text css={{ marginTop: 'tight' }}>Add</Text>;
